var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-xs-center" },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": 400 },
          model: {
            value: _vm.modalMensajeValidacion,
            callback: function($$v) {
              _vm.modalMensajeValidacion = $$v
            },
            expression: "modalMensajeValidacion"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v(_vm._s(_vm.titulo))]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", [_vm._v(_vm._s(_vm.mensaje))]),
              _vm.items
                ? _c("v-card-text", [
                    _c(
                      "ul",
                      _vm._l(_vm.items, function(item) {
                        return _c("li", { key: item }, [_vm._v(_vm._s(item))])
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#526da5", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleAceptar()
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Aceptar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }